import React, { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import QuestionsDialog from "../shared/QuestionsDialog";
import SimpleConfigTable from "../shared/SimpleConfigTable";
import { questionnairesApi } from "../../../../services/FeedbackServices";
import TablePagerBar from "../../TicketManagement/shared/TablePagerBar";

export default function QuestionsPanel() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [pagination, setPagination] = useState({ page: 1, perPage: 10 });

  const fetchRows = () => {
    questionnairesApi("get")
      .then((res) => {
        setRows(res?.data || []);
      })
      .catch(() => {
        setRows([]);
      });
  };

  useEffect(() => {
    fetchRows();
  }, []);

  useEffect(() => {
    setPagination({ page: 1, perPage: 10 });
  }, [rows?.length]);

  const columns = useMemo(
    () => [
      { key: "museum_name", label: "Museum Type" },
      { key: "code", label: "Code" },
      { key: "question", label: "Question" },
      { key: "is_active", label: "Active" },
    ],
    []
  );

  const displayRows = useMemo(() => {
    return (rows || []).map((r) => ({
      ...r,
      museum_name: r?.museum_type?.name || "-",
      is_active: r?.is_active ? "Yes" : "No",
    }));
  }, [rows]);

  const pagedRows = useMemo(() => {
    const page = pagination.page || 1;
    const perPage = pagination.perPage || 10;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return (displayRows || []).slice(start, end);
  }, [displayRows, pagination.page, pagination.perPage]);

  const handleAdd = () => {
    setEditRow(null);
    setOpen(true);
  };

  const handleEdit = (row) => {
    setEditRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditRow(null);
  };

  const handleSubmit = (payload) => {
    const id = payload?.id;
    if (id) {
      const patchPayload = {
        code: payload?.code,
        name: payload?.name,
        description: payload?.description,
        museum_type_id: payload?.museum_type_id,
        question: payload?.question,
        is_active: !!payload?.is_active,
      };
      questionnairesApi("patch", patchPayload, null, id)
        .then(() => {
          fetchRows();
          handleClose();
        })
        .catch(() => {});
      return;
    }

    questionnairesApi("post", payload)
      .then(() => {
        fetchRows();
        handleClose();
      })
      .catch(() => {});
  };

  const handleInactive = (id) => {
    questionnairesApi("delete", null, null, id)
      .then(() => fetchRows())
      .catch(() => {});
  };

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button variant={"contained"} onClick={handleAdd} className={"text-capitalize"}>
          + Add Question
        </Button>
      </Box>

      <SimpleConfigTable columns={columns} rows={pagedRows} onEdit={handleEdit} onLogicalDelete={handleInactive} />

      <TablePagerBar
        perPage={pagination.perPage}
        onPerPageChange={(e) => setPagination((p) => ({ ...p, perPage: Number(e.target.value), page: 1 }))}
        total={displayRows?.length || 0}
        page={pagination.page}
        onPageChange={(_, page) => setPagination((p) => ({ ...p, page }))}
      />

      {open && <QuestionsDialog open={open} row={editRow} onClose={handleClose} onSubmit={handleSubmit} />}
    </Box>
  );
}
